import React, { useState, useEffect, useReducer } from "react";
import "../common/dle/dle.css";
import _ from "lodash";
import { useParams, Link } from "react-router-dom";
import ThemeSwitch from "../common/themeSwitch/ThemeSwitch";
import ScrollView from "devextreme-react/scroll-view";
import * as utils from "../../common/utils";
import * as actions from "../../actions/siteDetails";
import siteReducer from "../../reducers/siteDetails";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import RailGrid from "../common/railGrid/RailGrid";
import MOC from "../common/managementOfChange/ManagementOfChange";
import Incident from "../common/incidents/Incident";
import Gemba from "../common/gembaTracking/GembaTracking";
import HSECommunications from "../common/hseCommunication/HSECommunications";
import TableauRender from "../common/tableauRender/TableauRender";
import DowntimeReason from "../common/downtimeReason/DowntimeReason";
import { SpeedDialAction } from "devextreme-react/speed-dial-action";
import Communications from "../common/communications/Communications";
import NexusCalendar from "../common/nexusCalendar/NexusCalendar";
import MeetingTimer from "../common/MeetingTimer";
import { postUserLog } from "../../actions/common";
import NX_CONST from "../../common/constants";
import PrivateSite from "../common/PrivateSite";
import WhiteBoard from "../common/WhiteBoard/WhiteBoard";
import Header from "./Header";
import SafetyMsg from "../common/safetyMsg/SafetyMsg";
import TabSwitcher from "./TabSwitcher";
import OPH from "../oph/OPH";
import RPS from "../common/rps/RPS";
import Sps from "../sps/Sps";
import { useSelector } from "react-redux";
import CostMetric from "../common/dle/CostMetric";
import { set, get, setLocal, getLocal } from "../../common/utils.js";
import QualityMetric from "../common/FPY/QualityMetric";
import SmessModal from "./SmessModal";
import GembaWalkPriorities from "./GembaWalkPriorities";
import Andon from "../common/Andon";
import ScheduleAttainment from "../common/scheduleAttainment/ScheduleAttainment";
import OPHAttainment from "../common/ophAttainment/OPHAttainment";
import MultiSurvey from "../common/multiSurvey/MultiSurvey";
import SA3 from "../sa3/SA3";
import SA3Grid from "../sa3/SA3Grid";
import ScrollToTop from "../../ScrollToTop";
import { alert } from "devextreme/ui/dialog";
import config from "../../common/config";

const initialState = {
  template: [],
  tableuaData: "",
  tierInfo: {},
  userData: null,
  siteInfo: null,
  tableuaInfo: null,
};
// Function to get the value from local storage
const getValueFromLocalStorage = () => {
  const value = localStorage.getItem("IsExpand");
  return value === "true";
};
const DigitalTier = (props) => {
  const { sbg, site, tier } = useParams();
  const [state, dispatch] = useReducer(siteReducer, initialState);
  const [activeItem, setActiveItem] = useState(0);
  const [andonMetric, setandonMetric] = useState([]);
  const [showRPS, setShowRPS] = useState(false);
  const [showSA3, setShowSA3] = useState(false);
  const [isExpanded, setIsExpanded] = useState(
    localStorage.getItem("IsExpand") != null ? getValueFromLocalStorage() : true
  );
  const [widgetExpand, setWidgetExpand] = useState([]);
  const [andonTriggerVal, setandonTrigger] = useState("");
  const [siteInformation, SetsiteInformation] = useState({});
  const queryProps = utils.getUrlQueryData();
  const activeTab = queryProps.tab ? queryProps.tab : "";
  const [isTableuaLoaded, setTableuaState] = useState(0);
  const [isPrivate, setIsPrivate] = useState(null);
  const fBCnfg = {
    label: "",
    hint: "Structured Problem Solving",
    index: 1,
    icon: "fas fa-lightbulb",
  };
  const a3Cnfg = {
    label: "",
    hint: "Strategic A3",
    index: 1,
    icon: "fas fa-cog",
  };
  const {
    template,
    userData,
    userDetailsAppaccess,
    tierInfo,
    siteInfo,
    tableuaInfo,
  } = state;
  const isEditable = userDetailsAppaccess
    ? utils.isEditable(userDetailsAppaccess)
    : null;
  const saveMeetingTime = (data) => {
    data.siteId = site;
    data.tierId = tier;
    actions.saveMeetingDuration(dispatch, data);
  };
  const DigitalTierUserdata = useSelector(
    (state) => state.home.UserProfiledata
  );

  const andonTrigger = () => {
    setandonTrigger("set");
    config.DEV_DISPLAY_OPTIONS &&
      AsyncCallHandler(
        NEXUS_CONST.GET_METRIC_ANDON + "tierId=" + tier,
        NEXUS_CONST.GET
      ).then((res) => {
        setandonMetric(res.data);
      });
  };

  useEffect(() => {
    AsyncCallHandler(NEXUS_CONST.FETCH_SITE_LIST + site, NEXUS_CONST.GET).then(
      (res) => {
        SetsiteInformation(res.data);
      }
    );
  }, []);

  useEffect(
    () => {
      config.DEV_DISPLAY_OPTIONS &&
        AsyncCallHandler(
          NEXUS_CONST.GET_METRIC_ANDON + "tierId=" + tier,
          NEXUS_CONST.GET
        ).then((res) => {
          setandonMetric(res.data);
        });
    },
    [tier],
    andonTriggerVal
  );
  // setTimeout(() => {

  const dleFlag = (tier, currentTab) => {
    let andonindicator = andonMetric?.find(
      (item) =>
        item.tierId == tier &&
        item.itemId == "costMetric" &&
        item.metric == currentTab
    )?.andon;
    if (andonindicator == "RED") {
      return "dle-indicator";
    } else if (andonindicator == "GREEN") {
      return "dle-indicator-green";
    } else {
      return "dle-indicator-none ";
    }
  };

  const fpyflag = (tier, currentTab) => {
    let andonindicator = andonMetric?.find(
      (item) =>
        item.tierId == tier &&
        item.itemId == "qualityMetric" &&
        item.metric == currentTab
    )?.andon;
    if (andonindicator == "RED") {
      return "dle-indicator";
    } else if (andonindicator == "GREEN") {
      return "dle-indicator-green";
    } else {
      return "dle-indicator-none ";
    }
  };
  const schAttainmentFlag = (tier, currentTab) => {
    let andonindicator = andonMetric?.find(
      (item) =>
        item.tierId == tier &&
        item.itemId == "deliveryMetric" &&
        item.metric == currentTab
    )?.andon;
    if (andonindicator == "RED") {
      return "dle-indicator";
    } else if (andonindicator == "GREEN") {
      return "dle-indicator-green";
    } else {
      return "dle-indicator-none ";
    }
  };
  const ophAttainmentFlag = (tier, currentTab) => {
    let andonindicator = andonMetric?.find(
      (item) =>
        item.tierId == tier &&
        item.itemId == "deliveryMetricOPH" &&
        item.metric == currentTab
    )?.andon;
    if (andonindicator == "RED") {
      return "dle-indicator";
    } else if (andonindicator == "GREEN") {
      return "dle-indicator-green";
    } else {
      return "dle-indicator-none ";
    }
  };

  const surveyFlag = (tier, currentTab, name) => {
    let splitName = name.filter.split("_")[2];
    let andonindicator = andonMetric?.find(
      (item) =>
        item.tierId == tier &&
        item.metric == template[activeItem].title &&
        item.itemId == currentTab &&
        item.name == splitName
    )?.andon;

    if (andonindicator == "RED") {
      return "dle-indicator";
    } else if (andonindicator == "GREEN") {
      return "dle-indicator-green";
    } else {
      return "dle-indicator-none ";
    }
  };

  const [rpsPopUpMgr, setRPSPopUpMgr] = useState(false);
  const [sa3PopUpMgr, setSA3PopUpMgr] = useState(false);
  const handleRPS = () => {
    postUserLog({
      event: "SPS Launch",
      data: {
        action: `SPS Widget launch`,
        module: "Digital Tier",
        section: template[activeItem].title,
        siteUId: site,
        widget: "Structured Problem Solving",
        tierId: tier,
      },
    });
    setRPSPopUpMgr(true);
  };
  const handleSA3 = () => {
    postUserLog({
      event: "A3 Launch",
      data: {
        action: `A3 Widget launch`,
        module: "Digital Tier",
        section: template[activeItem].title,
        siteUId: site,
        widget: "Strategic A3",
        tierId: tier,
      },
    });
    setSA3PopUpMgr(true);
  };

  const expandwidget = (d, isExpanded) => {
    setWidgetExpand(isExpanded ? [] : d);
  };

  const getTableauTplInfo = (d, t, p) => utils.tableuaTplInfo(d, t, p);

  const getWidget = (data, widgetIndex, col, isArr, isMulti) => {
    if (state.tableuaData === "") return "";
    if (!data.isActive) return "";
    let isExpandedWidget = false;

    let enableExpand = col.length > 1 ? true : false;
    if (
      widgetExpand.length > 0 &&
      widgetExpand[0] == widgetIndex[0] &&
      widgetExpand[1] != widgetIndex[1]
    ) {
      return "";
    }

    if (
      widgetExpand.length > 0 &&
      widgetExpand[0] == widgetIndex[0] &&
      widgetExpand[1] == widgetIndex[1]
    ) {
      isExpandedWidget = true;
    }
    let {
      performance,
      safety,
      quality,
      delivery,
      cost,
      inventory,
      people,
      token,
    } = state.tableuaData;

    let expandIcon = isExpandedWidget ? "fa-minus-square" : "fa-expand";

    let widget;

    switch (data.itemId) {
      case "perfTableua":
        widget = performance ? (
          <TableauRender data={getTableauTplInfo(performance, token)} />
        ) : (
          ""
        );
        break;

      case "safetyCross":
        widget = safety ? (
          <TableauRender data={getTableauTplInfo(safety, token)} />
        ) : (
          ""
        );
        break;

      case "qualityTableua":
        widget = quality ? (
          <TableauRender data={getTableauTplInfo(quality, token)} />
        ) : (
          ""
        );
        break;

      case "inventoryTableua":
        widget = inventory ? (
          <TableauRender data={getTableauTplInfo(inventory, token)} />
        ) : (
          ""
        );
        break;

      case "costMetric":
        // case "dleWidget":
        widget = "";
        return (
          <CostMetric
            tierId={tier}
            siteId={site}
            dleFlag={dleFlag(tier, template[activeItem].title)}
            title={"Direct Labor Efficeiency"}
            andon={andonTrigger}
            navigationOn={template[activeItem].title}
          />
        );
        break;
      // return (
      //   <>
      //     <div className="col" style={{ margin: '0px' }}>
      //       <div className="col-heading">
      //         {"Direct Labour Efficeiency"}

      //         <span
      //           className={
      //             dleFlag(tier)
      //             // andonMetric === "RED"
      //             //   ? "dle-indicator"
      //             //   : "dle-indicator-green"
      //           }
      //         ></span>
      //       </div>
      //     </div>
      //     <div className="col-body">
      //       <CostMetric tierId={tier} siteId={site} />;
      //     </div>
      //   </>
      // );

      case "costTableua":
        widget = cost ? (
          <TableauRender data={getTableauTplInfo(cost, token)} />
        ) : (
          ""
        );
        break;

      case "peopleTableua":
        widget = people ? (
          <TableauRender data={getTableauTplInfo(people, token)} />
        ) : (
          ""
        );
        break;

      case "deliveryTableua":
        widget = delivery ? (
          <TableauRender data={getTableauTplInfo(delivery, token)} />
        ) : (
          ""
        );
        break;

      case "gemba":
        widget = (
          <Gemba
            tierId={tier}
            siteId={site}
            widgetInfo={data}
            userData={userData}
            isEditable={isEditable}
          />
        );
        break;

      case "ophWidget":
        widget = "";
        let title = data.title;
        if (
          NEXUS_CONST.ENV !== "production" &&
          NEXUS_CONST.L_SERIES.indexOf(tier) > -1
        )
          title = "Connected " + data.title;
        if (state.tierInfo.tierLevel === 1)
          return (
            <OPH
              site={site}
              tier={data.filter && data.filter != "" ? data.filter : tier}
              title={title}
              isEditable={isEditable}
              siteInformation={siteInformation}
              lastUpdatedOn={state.tierInfo.lastUpdatedDate}
              moduleName={
                template.length > 0 ? template[activeItem]["title"] : "OPH"
              }
            />
          );
        break;

      case "rpsWidget":
        widget = (
          <RPS
            tab={data.filter}
            data={template}
            tierId={tier}
            siteId={site}
            title={data.title}
            activeItem={activeItem}
            template={template}
            isEditable={isEditable}
            FromDGrpsPopUpMgr={rpsPopUpMgr}
            widgetId={data.widgetId}
          />
        );
        break;

      case "hseCommunication":
        widget = (
          <HSECommunications
            tierId={tier}
            siteId={site}
            userData={userData}
            isEditable={isEditable}
          />
        );
        break;

      // case "incidentWidget":
      //   widget = (
      //     <Incident tierId={tier} siteId={site} isEditable={isEditable} />
      //   );
      //   break;

      // case "incident":
      //   widget = "";
      //   break;

      case "mocWidget":
        widget = <MOC tierId={tier} siteId={site} isEditable={isEditable} />;
        break;

      case "whiteboard":
        widget = <WhiteBoard siteId={site} widgetId={data.widgetId} />;
        break;

      case "managementofchange":
        widget = "";
        break;

      case "gembaTracking":
        return (
          <div className="col" key={data.itemId + "_" + utils.getRandomNum()}>
            {enableExpand && (
              <span
                className="full-screen-widget"
                onClick={() => expandwidget(widgetIndex, isExpandedWidget)}
              >
                <i className={"fas " + expandIcon}></i>
              </span>
            )}
            <div className="col-heading">{data.title}</div>
            <div className="col-body">
              <Gemba
                tierId={tier}
                siteId={site}
                widgetInfo={data}
                isEditable={isEditable}
              />
            </div>
            <div></div>
            {/* <div className="col-heading">{"Incident"}</div> */}
            {/* <div className="col-body">
              <Incident tierId={tier} siteId={site} isEditable={isEditable} />
            </div> */}
            <div className="col-heading">{"Management of Change"}</div>
            <div className="col-body">
              <MOC tierId={tier} siteId={site} isEditable={isEditable} />
            </div>
          </div>
        );

      case "perfRailGrid":
        widget = (
          <RailGrid
            tierId={tier}
            siteId={site}
            tab={data.filter}
            tabData={template}
            currenttab={template[activeItem]}
            widgetId={data.widgetId}
            siteDate={state.tierInfo.lastUpdatedDate}
          />
        );
        break;

      case "railGrid":
        widget = (
          <RailGrid
            tierId={tier}
            siteId={site}
            tab={data.filter}
            tabData={template}
            currenttab={template[activeItem]}
            widgetId={data.widgetId}
            siteDate={state.tierInfo.lastUpdatedDate}
          />
        );
        break;

      case "qualityRail":
        widget = (
          <RailGrid
            tierId={tier}
            siteId={site}
            tab={data.filter}
            tabData={template}
            currenttab={template[activeItem]}
            widgetId={data.widgetId}
            siteDate={state.tierInfo.lastUpdatedDate}
          />
        );
        break;

      case "deliveryRail":
        widget = (
          <RailGrid
            tierId={tier}
            siteId={site}
            tab={data.filter}
            tabData={template}
            currenttab={template[activeItem]}
            widgetId={data.widgetId}
            siteDate={state.tierInfo.lastUpdatedDate}
          />
        );
        break;

      case "inventoryRail":
        widget = (
          <RailGrid
            tierId={tier}
            siteId={site}
            tab={data.filter}
            tabData={template}
            currenttab={template[activeItem]}
            widgetId={data.widgetId}
            siteDate={state.tierInfo.lastUpdatedDate}
          />
        );
        break;

      case "costRail":
        widget = (
          <RailGrid
            tierId={tier}
            siteId={site}
            tab={data.filter}
            tabData={template}
            currenttab={template[activeItem]}
            widgetId={data.widgetId}
            siteDate={state.tierInfo.lastUpdatedDate}
          />
        );
        break;

      case "peopleRail":
        widget = (
          <RailGrid
            tierId={tier}
            siteId={site}
            tab={data.filter}
            tabData={template}
            currenttab={template[activeItem]}
            widgetId={data.widgetId}
            siteDate={state.tierInfo.lastUpdatedDate}
          />
        );
        break;

      case "downtimeReason":
        widget = (
          <DowntimeReason
            tierId={tier}
            siteId={site}
            isEditable={isEditable}
            widgetId={data.widgetId}
          />
        );
        break;

      case "communication":
        widget = (
          <Communications
            expandIcon={expandIcon}
            widgetId={data.widgetId}
            tierId={tier}
            siteId={site}
            data={template[activeItem]}
            isEditable={isEditable}
          />
        );
        break;

      case "calendar":
        widget = (
          <NexusCalendar tierId={tier} siteId={site} isEditable={isEditable} />
        );
        break;

      //Custom items
      case "rail":
        widget = (
          <RailGrid
            tierId={tier}
            siteId={site}
            tabData={template}
            tab={data.filter}
            currenttab={template[activeItem]}
            activeItem={activeItem}
            isEditable={isEditable}
            widgetId={data.widgetId}
            siteDate={state.tierInfo.lastUpdatedDate}
          />
        );
        break;
      case "qualityMetric":
      case "fpyWidget":
        widget = "";
        return (
          <QualityMetric
            tierId={tier}
            siteId={site}
            fpyflag={fpyflag(tier, template[activeItem].title)}
            title={"First Pass Yield"}
            andon={andonTrigger}
            navigationOn={template[activeItem].title}
          />
        );
        break;

      case "html":
      case "inlineFile":
        widget = renderHtmlContent(data.description);
        break;

      case "tableau":
        let props = null;
        let tKey = template[activeItem]["title"].toLowerCase();
        if (tableuaInfo && tableuaInfo[tKey]) {
          props = tableuaInfo[tKey];
        }
        widget = data.description ? (
          <TableauRender
            data={getTableauTplInfo(data.description, token, props)}
          />
        ) : (
          ""
        );
        break;

      case "alertsMsgs":
        return (
          <SafetyMsg
            siteId={site}
            tierId={tier}
            type={data.widgetId}
            data={data}
            key={data.widgetId}
            isEditable={isEditable}
          />
        );
        break;
      case "gembawalk":
        {
          if (tierInfo?.tierLevel === 4) {
            return (
              <GembaWalkPriorities
                andonTitle={<Andon data={andonMetric} type={data.itemId} />}
                navigationTabOn={template[activeItem].title}
              />
            );
          }
        }
        break;
      case "deliveryMetric":
        {
          if (tierInfo?.tierLevel === 1)
            return (
              <ScheduleAttainment
                tierId={tier}
                siteId={site}
                schAttainmentFlag={schAttainmentFlag(
                  tier,
                  template[activeItem].title
                )}
                andon={andonTrigger}
                navigationOn={template[activeItem].title}
              />
            );
        }
        break;

      case "deliveryMetricOPH":
        {
          if (tierInfo?.tierLevel === 1)
            return (
              <OPHAttainment
                tierId={tier}
                siteId={site}
                ophAttainmentFlag={ophAttainmentFlag(
                  tier,
                  template[activeItem].title
                )}
                andon={andonTrigger}
                tierInfo={tierInfo}
                navigationOn={template[activeItem].title}
              />
            );
        }
        break;
      case "multiSurveyWidget":
        {
          if (tierInfo?.tierLevel === 1)
            return (
              <MultiSurvey
                tierId={tier}
                siteId={site}
                surveyFilter={data.filter}
                title={data.title}
                siteDate={state.tierInfo.lastUpdatedDate}
                surveyFlag={surveyFlag(
                  tier,
                  "multiSurveyWidget",
                  data
                  // activeItem
                )}
                andon={andonTrigger}
                navigationOn={template[activeItem].title}
                tierInfo={tierInfo}
              />
            );
        }
        break;
      case "sa3Widget":
        widget = (
          <SA3Grid
            tab={data.filter}
            data={template}
            tierId={tier}
            siteId={site}
            title={data.title}
            activeItem={activeItem}
            template={template}
            isEditable={isEditable}
            FromDGsa3PopUpMgr={sa3PopUpMgr}
            navigationOn={template[activeItem].title}
            siteDate={state.tierInfo.lastUpdatedDate}
          />
        );
        break;
      default:
        widget = <div></div>;
        break;
    }

    if (isArr) {
      if (widget) {
        if (isMulti) {
          return (
            <div
              className="multi-wid-blk-adj"
              key={data.itemId + "_" + utils.getRandomNum()}
            >
              <div className="multi-wid-adj"></div>
              {enableExpand && (
                <span
                  className="full-screen-widget"
                  onClick={() => expandwidget(widgetIndex, isExpandedWidget)}
                >
                  <i className={"fas " + expandIcon}></i>
                </span>
              )}
              <div className="col-heading">{data.title} </div>
              <div className="multi-wid-container">
                <div className="col-body">{widget}</div>
              </div>
            </div>
          );
        } else {
          return (
            <>
              {enableExpand && (
                <span
                  className="full-screen-widget"
                  onClick={() => expandwidget(widgetIndex, isExpandedWidget)}
                >
                  <i className={"fas " + expandIcon}></i>
                </span>
              )}
              <div className="col-heading">{data.title} </div>
              <div className="multi-wid-container">
                <div className="col-body">{widget}</div>
              </div>
            </>
          );
        }
      } else return "";
    } else {
      return widget ? (
        <div className="col" key={data.itemId + "_" + utils.getRandomNum()}>
          {enableExpand && (
            <span
              className="full-screen-widget"
              onClick={() => expandwidget(widgetIndex, isExpandedWidget)}
            >
              <i className={"fas " + expandIcon}></i>
            </span>
          )}
          <div className="col-heading">{data.title} </div>
          <div className="col-body">{widget}</div>
        </div>
      ) : (
        ""
      );
    }
  };

  const renderHtmlContent = (data) => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `${data}`,
        }}
      ></div>
    );
  };

  const switchTabs = () =>
    setActiveItem((preVal) => {
      let t = preVal + 1;
      return t < template.length ? t : 0;
    });

  const formatSqdicp = (txt) => {
    let SQDICP = NX_CONST.MENU_SQDICP;
    let val = txt.toLowerCase();
    if (txt?.length > 0)
      //if (SQDICP.indexOf(val) > -1)
      return isExpanded ? (
        <>
          {" "}
          <span className="txt-sqdicp">{val.charAt(0)}</span>
          {txt.substring(1)}
        </>
      ) : (
        <>
          {" "}
          <span className="txt-sqdicp">{val.charAt(0)}</span>
        </>
      );
    else return isExpanded ? txt : "";
  };

  useEffect(() => {
    let isPreview =
      window.location.pathname.indexOf("preview") > -1 ? "&isFlag=true" : "";
    document.title = isPreview
      ? "Honeywell Nexus - Preview"
      : "Honeywell Nexus";
    utils.set("isAuthcomlpeted", 0);
    actions.getUserData(dispatch, site);
    actions.getUserDataAppAccess(dispatch, `siteId=${site}&tierId=${tier}`);
    actions.getSiteInfo(dispatch, site);
    actions.getTableuaInfo(dispatch, `siteid=${site}&tierid=${tier}`);
    actions.getUserDataAppAccess(dispatch, `siteId=${site}&tierId=${tier}`);
    actions.fetchActiveTemplate(
      dispatch,
      `siteid=${site}&tierid=${tier}${isPreview}`
    );
    actions.getTableuaData(dispatch, tier);
    actions.getTierInfo(dispatch, `siteid=${site}&tierid=${tier}`);
    let viewInfo = isPreview ? "Preview" : "view";
    postUserLog({
      event: "Screen navigation",
      data: {
        action: "Dashboard screen " + viewInfo,
        module: "Digital Tier",
        section: "Customize",
        siteUId: site,
        widget: "",
        tierId: tier,
      },
    });

    return () => {
      document.title = "Honeywell Nexus";
    };
  }, []);

  useEffect(() => {
    let activeIndex = 0;
    let widgetId = "rpsWidget";
    let sa3WidgetId = "sa3Widget";
    if (template.length > 0) {
      activeIndex = template.findIndex((data) => data.isActive);
      if (activeIndex > -1) {
        setActiveItem(activeIndex);
      } else setActiveItem(0);
      template.map((k) => {
        k.layout.map((d) => {
          d.rowItems.map((i) => {
            if (_.isArray(i))
              i.map((j) => {
                if (j.itemId == widgetId && j.isActive) {
                  setShowRPS(true);
                }
                if (j.itemId == sa3WidgetId && j.isActive) {
                  setShowSA3(true);
                }
              });
            else if (i.itemId == widgetId && i.isActive) {
              setShowRPS(true);
            } else if (i.itemId == sa3WidgetId && i.isActive) {
              setShowSA3(true);
            }
          });
        });
      });
    }

    if (template && template.length > 0) {
      let tabVal = 0;
      if (activeTab) {
        tabVal = template.findIndex((d) => d.id == activeTab);
      }
      if (!template[tabVal]) tabVal = 0;
      setActiveItem(tabVal);
    }
  }, [template]);

  const onMenuSelect = (i, t) => {
    setActiveItem(i);
    setWidgetExpand([]);
    postUserLog({
      event: "Dashboard Menu change",
      data: {
        action: "Dashboard Menu changed to " + t,
        module: "Digital Tier",
        section: t,
        siteUId: site,
        widget: "",
        tierId: tier,
      },
    });
  };

  useEffect(() => {
    if (siteInfo) {
      if (!siteInfo.isPrivate) setIsPrivate(false);
      else if (siteInfo.isPrivate) {
        if (userData && userData.hId)
          setIsPrivate(utils.isPrivateSite(userData, siteInfo));
      }
    }
  }, [siteInfo, userData]);

  let widgetexpand =
    localStorage.getItem("IsExpand") != null
      ? localStorage.getItem("IsExpand")
      : true;
  const showLeftPanel = () => {
    // setIsExpanded(!isExpanded);
    setLocal("IsExpand", !isExpanded);
    setIsExpanded(
      localStorage.getItem("IsExpand") != null
        ? getValueFromLocalStorage()
        : !isExpanded
    );
  };

  return (
    <>
      {isPrivate === false && (
        <>
          <Header isExpanded={isExpanded} showLeftPanel={showLeftPanel} />

          <section className="page-content page-height-change dashboard">
            <div className="dashboard-wrap">
              <div
                className="left-sidebar"
                style={!isExpanded ? { width: "180px" } : {}}
              >
                <ScrollView className="left-menu-height">
                  {" "}
                  <ul className="scroll">
                    {template.map((data, i) => {
                      if (data.isActive) {
                        return (
                          <li
                            key={i}
                            className={
                              activeItem === i ? "node active" : "node"
                            }
                            onClick={() => onMenuSelect(i, data.title)}
                            title={data.title}
                          >
                            <div className="node-wrap w-100">
                              <span
                                className={
                                  "icon node-icon " + data.iconCls + "-icon"
                                }
                              ></span>
                              <div className="dt-title">
                                {formatSqdicp(data.title)}
                                <Andon data={andonMetric} title={data.title} />
                              </div>
                            </div>
                          </li>
                        );
                      }
                    })}
                  </ul>
                </ScrollView>

                {
                  <>
                    {state.tierInfo &&
                      state.tierInfo.sliderDuration != "undefined" && (
                        <TabSwitcher
                          timeVal={state.tierInfo.sliderDuration}
                          switchTabs={switchTabs}
                          siteId={site}
                        />
                      )}
                    <button
                      className="dash-head-btn-adj"
                      onClick={(e) => {
                        showLeftPanel();
                      }}
                    >
                      <span
                        className={
                          isExpanded
                            ? "fa fa-angle-double-left"
                            : "fa fa-angle-double-right"
                        }
                      ></span>
                    </button>
                  </>
                }
                {isExpanded && <ThemeSwitch />}
              </div>
              <div className="content-area">
                <div className="content-head">
                  <ScrollToTop></ScrollToTop>

                  {
                    /*!isExpanded && <button className="dash-head-btn-adj" onClick={(e) => { e.preventDefault(); showLeftPanel() }}><i className="fa fa-angle-double-right"></i></button>*/
                    !isExpanded && (
                      <header className="w-30">
                        <Link to="/">
                          <div className="logo">
                            <span className="site-logo"></span>
                          </div>
                        </Link>
                      </header>
                    )
                  }

                  <span
                    className="icon isc-icon "
                    title="Powered by ISC"
                  ></span>
                  <div className="heading">
                    <h2>
                      {template.length > 1 ? template[activeItem].title : ""} in{" "}
                      {state.tierInfo.tierName}, {state.tierInfo.siteName}{" "}
                      {window.location.pathname.indexOf("preview") > -1 ? (
                        <span className="blink_me"> - Preview mode</span>
                      ) : (
                        ""
                      )}
                    </h2>
                    <p>Last updated on {state.tierInfo.lastUpdatedDate}</p>
                  </div>
                  <ul className="notification ">
                    <li>
                      <a
                        onClick={() => {
                          let shareUrl =
                            window.location.origin +
                            `/dashboard/${sbg}/${site}/${tier}?tab=` +
                            (template.length > 0
                              ? template[activeItem]["id"]
                              : "");
                          navigator.clipboard.writeText(shareUrl);
                          alert(shareUrl, "Copied!");
                        }}
                      >
                        <i class="fas fa-share"></i> <span>Share</span>
                      </a>
                    </li>
                    <li style={{ marginTop: "10px" }}>
                      {" "}
                      {state.tierInfo && state.tierInfo.meetingDuration && (
                        <MeetingTimer
                          maxMin={state.tierInfo.meetingDuration}
                          siteId={site}
                          update={saveMeetingTime}
                        />
                      )}
                    </li>

                    {userData && utils.isSiteOwner(userData) && (
                      <li>
                        <Link
                          to={
                            `/customize/dashboard/${site}/${tier}/${sbg}?tab=` +
                            (template.length > 0
                              ? template[activeItem]["id"]
                              : "")
                          }
                        >
                          <i className="icon customize-icon"></i>{" "}
                          <span>Customize</span>
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link to={`/sitehome/${sbg}/${site}`}>
                        <i className="icon home-icon"></i> <span>Home</span>
                      </Link>
                    </li>

                    <li className="hide">
                      <a href="#" className="new-notification">
                        <i className="icon notification-icon"></i>{" "}
                        <span>Inbox</span>
                      </a>
                      <div className="notification-box">
                        <div className="card">
                          <div className="notification-wrap">
                            <div className="profile-icon">
                              <span className="icon profile-icon"></span>
                            </div>
                            <div className="details">
                              <h4>Notification 1</h4>
                              <p>
                                Lorem ipsum dolor sit amet consectetur
                                adipisicing elit. Ducimus error quas nostrum
                                veniam corrupti? Quia officiis non neque nam
                                saepe nesciunt. Error iste sequi quisquam. Quo
                                ratione deleniti dolorem vitae.
                              </p>
                            </div>
                          </div>
                          <span className="icon kebab-icon open-notification"></span>
                          <div className="notification-action">
                            <span>
                              <i className="icon back-icon"></i>
                              <span>Back</span>
                            </span>
                            <span>
                              <i className="icon hide-icon"></i>
                              <span>Hide</span>
                            </span>
                            <span>
                              <i className="icon delete-icon"></i>
                              <span>Delete</span>
                            </span>
                          </div>
                        </div>

                        <div className="view-more">View More</div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="breadcrumb-wrap">
                  <div className="breadcrumb">
                    <span
                      className={"icon icon-" + utils.getSbgName(sbg)}
                    ></span>
                    <ul>
                      <li>
                        <Link to={`/home/${sbg}`}>
                          {utils.getSbgNameTxt(sbg)}
                        </Link>
                      </li>
                      <li>
                        <Link to={`/sitehome/${sbg}/${site}`}>
                          {state.tierInfo.siteName}
                        </Link>
                      </li>

                      <li>
                        <Link to={`/tiers/${sbg}/${site}/digital`}>
                          Digital Tier
                        </Link>
                      </li>
                      <li>{state.tierInfo.tierName}</li>
                    </ul>
                  </div>
                  <ul className="right-breadcrumb">
                    <li>
                      Responsible /{" "}
                      <a
                        href={`mailto:${state.tierInfo.responsibleEmail}`}
                        className="name"
                      >
                        {state.tierInfo.responsiblePerson}
                      </a>
                    </li>
                    <li>
                      Alternate /{" "}
                      <a
                        href={`mailto:${state.tierInfo.alternateEmail}`}
                        className="name"
                      >
                        {state.tierInfo.alternatePerson}
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="content-body scroll digitalTierScrollView">
                  <ScrollToTop></ScrollToTop>

                  <div className="content-body scroll">
                    {template.length > 1 &&
                      (template[activeItem]["id"] === "safety" ||
                        template[activeItem]["id"] === "quality") && (
                        <SafetyMsg
                          siteId={site}
                          tierId={tier}
                          type={template[activeItem]["id"]}
                          data={template[activeItem]}
                        />
                      )}

                    {template.length >= 1 &&
                      userData &&
                      tableuaInfo &&
                      template[activeItem]["layout"].map((item, i) => (
                        <div className="rows" key={i}>
                          {item.rowItems.map((col, j) => {
                            if (!_.isArray(col))
                              //return getWidget(col, [i, j], item.rowItems)
                              return (
                                <>{getWidget(col, [i, j], item.rowItems)}</>
                              );
                            else {
                              let isMulti = col.length > 1 ? true : false;
                              if (
                                widgetExpand.length > 0 &&
                                widgetExpand[0] == i &&
                                widgetExpand[1] != j
                              ) {
                                return "";
                              } else
                                return (
                                  <div className="col multi-widget">
                                    {col.map((widget, k) =>
                                      getWidget(
                                        widget,
                                        [i, j],
                                        item.rowItems,
                                        true,
                                        isMulti
                                      )
                                    )}
                                  </div>
                                );
                            }
                          })}
                        </div>
                      ))}
                  </div>
                  {showRPS && (
                    <SpeedDialAction
                      onClick={handleRPS}
                      //  className="faBtn"
                      {...fBCnfg}
                    />
                  )}
                  {/* Changed the tier level requirement for showing SA3 from 3 to 1 */}
                  {showSA3 && tierInfo?.tierLevel >= 1 && (
                    <SpeedDialAction
                      onClick={handleSA3}
                      // className="faBtn"
                      {...a3Cnfg}
                    />
                  )}
                  {/* <SpeedDialAction
                    icon="add"
                    label="Add row"
                    index={1}
                  ////  onClick={this.addRow} 
                  />
                  <SpeedDialAction
                    icon="trash"
                    label="Delete row"
                    index={2}
                  // visible={selectedRowIndex !== undefined && selectedRowIndex !== -1}
                  // onClick={this.deleteRow} 
                  />
                  <SpeedDialAction
                    icon="edit"
                    label="Edit row"
                    index={3}
                  // visible={selectedRowIndex !== undefined && selectedRowIndex !== -1}
                  //  onClick={this.editRow} 
                  /> */}
                  {rpsPopUpMgr && (
                    <Sps
                      rpsId={0}
                      tierId={tier}
                      siteId={site}
                      activeItem={activeItem}
                      data={template}
                      closeShift={(d) => setRPSPopUpMgr(d)}
                      isRail={false}
                      isEditable={isEditable}
                    />
                  )}
                  {sa3PopUpMgr && (
                    <SA3
                      a3ID={0}
                      tierId={tier}
                      siteId={site}
                      activeItem={activeItem}
                      data={template}
                      closeShift={(d) => setSA3PopUpMgr(d)}
                      isRail={false}
                      isEditable={isEditable}
                      siteDate={state.tierInfo.lastUpdatedDate}
                      activeTab={template[activeItem].title}
                    />
                  )}
                </div>
              </div>
            </div>
          </section>
          {/* If Tier is 1 then render SmessModal Component */}
          {tierInfo?.tierLevel === 1 && config.DEV_DISPLAY_OPTIONS && (
            <SmessModal
              tierInfo={tierInfo}
              siteDate={state.tierInfo.lastUpdatedDate}
            />
          )}
        </>
      )}
      {isPrivate && (
        <section className="page-content">
          <PrivateSite site={siteInfo.siteName} />
        </section>
      )}
    </>
  );
};
export default DigitalTier;
